import {
    SET_ACCOUNT_LOADING,
    REMOVE_ACCOUNT_LOADING,
    SET_ACCOUNT_DATA
} from '../types';

const initialState = {
    loading: false, // Init loading state
    accountData: {},
    oldValue: ''
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ACCOUNT_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_ACCOUNT_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_ACCOUNT_DATA:
            return {
                ...state,
                accountData: { ...payload }
            };
        default:
            return state;
    }
}